<template>
  <div class="">
    <!-- <div class="row">
        <sp-card :valor="totalOcupantes" :descricao="$t('assistencia.perfil.totalOcupantes')"/>
    </div> -->

    <sp-360-panel class="flex xs12" :title="$t('assistencia.perfil.ocupantesPorSubprefeitura.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data : dataRef})" :footerComplementar="$t('assistencia.perfil.rodape')">
      <!-- <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="true" :habilitarLegenda='false'/> -->
      <sp360-chart  id="totalPorSub" type="vertical-bar" :data="totalPorSub.data" :options="totalPorSub.options" />
    </sp-360-panel>

    <div class="row">
      <div class="flex col md6 sm12">
        <sp-360-panel :title="$t('assistencia.perfil.escolaridade')" :footerText="$t('rodape.fonteData', {fonte: fonte, data : dataRef})" :footerComplementar="$t('assistencia.perfil.escolaridadeRodape')">
          <sp360-chart id="escolaridade" type="line" :data="escolaridade.data" :options="escolaridade.options" />
        </sp-360-panel>
      </div>
      <div class="flex col md6 sm12">
        <sp-360-panel :title="$t('assistencia.perfil.racaSexo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data : dataRef})" :footerComplementar="$t('assistencia.perfil.racaSexoRodape')">
          <sp360-chart id="racaSexo" type="vertical-bar" :data="racaSexo.data" :options="racaSexo.options" />
        </sp-360-panel>
      </div>
    </div>

    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('assistencia.perfil.etariedade')" :footerText="$t('rodape.fonteData', {fonte: fonte, data : dataRef})" :footerComplementar="$t('assistencia.perfil.etariedadeRodape')">
          <sp360-chart id="faixaEtaria" type="pie" :data="faixaEtaria.data" :options="faixaEtaria.options" />
        </sp-360-panel>
      </div>

      <!-- <div class="flex col md6 sm12">
        <sp360-list id="lista" title="Orientacao " footerText="Orgãos ">
          <template v-for="(m, index) in listaOrientacao" class="list listas">
            <va-item >
              <va-item-section>
                <va-item-label>
                  {{ m.orientacao_sexual + " - " + m.total_pessoas }}
                </va-item-label>
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < listaOrientacao.length-1" />
          </template>
        </sp360-list>
      </div> -->
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import * as d3 from 'd3'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import { contains } from '@amcharts/amcharts4/.internal/core/utils/Iterator'

export default {
  name: 'perfil-ocupantes',
  mixins: [],
  components: {
    Sp360Panel,
    SpCard,
    Sp360Chart,
    SpMap,
    SPMapaNomes,
    Sp360DataTable,
    Sp360Panel,
    Sp360List,
  },
  data () {
    return {
      dataRef: null,
      fonte: null,
      mapaCores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      },
      cores: [],
      totalPorSub: {
        data: {},
        options: {},
      },

      escolaridade: {
        data: {},
        options: {},
      },

      racaSexo: {
        data: {},
        options: {},
      },

      faixaEtaria: {
        data: {},
        options: {},
      },
      totalOcupantes: 0,
      listaOrientacao: [],
    }
  },
  computed: {

  },
  created () {
    Promise.all([
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'SUBPREFEITURA' }),
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'SEXO,RACA' }),
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'GRAU_INSTRUCAO' }),
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'SEXO' }),
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'ORIENTACAO_SEXUAL' }),
      this.$store.dispatch('assistenciaSocial/buscarPerfisOcupacoesAgrupadosNoUltimoMes', { agrupamento: 'FAIXA_ETARIA' }),

    ]).then((response) => {
      this.fonte = response[0].data.sigla_orgao + '-' + response[0].data.fonte
      this.dataRef = new Date(response[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      this.cores = CorUtils.getVetorCoresPorTom('claro').slice(7)

      this.totalPorSub.options = this.getChartOptions('Subprefeitura', 'Total de Ocupantes')
      this.totalPorSub.options.legend.display = false
      this.totalPorSub.data = this.populateTotalPorSub(_.orderBy(response[0].data.data, 'total_pessoas', 'desc'), this.totalPorSub.options)

      this.racaSexo.options = this.getChartOptions(' ', 'Número de Ocupantes')
      this.totalPorSub.options.legend.display = false
      this.racaSexo.data = this.populateRacaSexo(response[1].data.data)

      this.escolaridade.options = this.getLineChartOptions(' ', 'Número de Ocupantes')
      this.escolaridade.data = this.populateEscolaridade(_.orderBy(response[2].data.data, 'total_pessoas'), this.cores, this.$store.getters.palette.transparent)

      this.totalOcupantes = this.getTotal(response[3].data.data)
      this.listaOrientacao = response[4].data.data// this.getListaOrientacao(response[4].data.data)

      this.populateFaixaEtaria(response[5].data.data)
    })
  },
  methods: {
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub !== id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub, true)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.subSelecionada = this.$refs.mapa.nomes[idNum].nome
        this.$refs.mapa.emulateClick(id)
        // this.$refs.mapa.pintarRegiao(id, CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO))
        this.refreshDashboard(idNum)
      } else {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub, true)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.subSelecionada = null
        this.refreshDashboard()
      }
      this.subSel = _.find(this.subs, (e) => { return e.nome === this.subSelecionada })
    },
    refreshDashboard () { },
    pintarMapa (data) {
      let dados = data

      dados = _.orderBy(dados, 'total_pessoas')
      let colorScale = d3.scaleLinear()
        .domain([0.1, dados[dados.length - 1]['total_pessoas']])
        .range([this.mapaCores.claro, this.mapaCores.escuro])

      dados.forEach(o => {
        let id = 'sub' + o.id_subprefeitura
        this.$refs.mapa.pintarRegiao(id, colorScale(o['total_pessoas']))
      })

      this.$refs.mapa.setLegenda(dados[0]['total_pessoas'], dados[dados.length - 1]['bercario_i'], 'Tempo Médio de Atendimento em Dias')
      this.criarlegenda(this.mapaCores)
    },

    getChartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 25,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
            },
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }
              return title
            },
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].label === 'Folha por Orgão' || details.datasets[tooltipItem.datasetIndex].label === 'Distribuição Per capita') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + 'R$' + currentValue.toLocaleString('pt-BR')
              } else if (details.datasets[tooltipItem.datasetIndex].label === 'Acumulado') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + MethGlob.formataPercentual(currentValue)
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label ? dataset.label + ': ' + currentValue.toLocaleString('pt-BR') : currentValue.toLocaleString('pt-BR')
              }
            },
          },
        },
        responsive: true,
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            type: 'logarithmic',

            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 15,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MethGlob.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              position: 'left',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return value
                },
              },
            },
          ],
        },
      }
    },

    getOptionPieChart () {
      return {
        responsive: true,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              let dataLabel = data.labels[tooltipItem.index]
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return (dataLabel + ': ' + value.toLocaleString('pt-BR'))
            },
          },
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 50,
            bottom: 30,
          },
        },
        plugins: {
          datalabels: {
            display: true,
            clamp: true,
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum)
              let og = Math.pow(10, 2)
              percentage = Math.floor(percentage * og) / og + '%'
              return percentage.replace('.', ',') + '\n' + MethGlob.formatarGrandesNumeros(value)
            },
            font: {
              size: 14,
              weight: 'bold',
            },
            anchor: 'end',
            align: function (context) {
              return context.dataIndex % 2 ? 'start' : 'end'
            },
            color: '#000',
          },
        },
      }
    },

    getLineChartOptions (legendaX, legendaY, percentual = true, milhar = false) {
      return {
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              let label = chart.datasets[0].label
              label += tooltipItem.yLabel.toLocaleString('pt-BR')
              return label
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 20,
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              maxTicksLimit: 10,
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            id: 'y-axis-1',
            type: 'logarithmic',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }],
        },
        plugins: {
          datalabels: {
            clamp: true,
            formatter: (value) => value.toLocaleString('pt-BR'),
            font: {
              // size: 16,
              weight: 'bold',
            },
            anchor: 'start',
            align: 'end',
            color: '#000',
            display: true,
          },
        },
      }
    },

    populateTotalPorSub (dados, options) {
      let chartData = { datasets: [], labels: [] }
	    let dataset = {
        backgroundColor: CorUtils.getCorPorNomeSp360('azul-columbia-claro'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: -90,
          align: 'end',
          display: 'true',
          font: {
            size: 18,
            weight: 'bold',
          },
        },
      }

      dados.forEach(e => {
        chartData.labels.push(e.subprefeitura)
        dataset.data.push(e.total_pessoas)
        dataset.label = 'Ocupantes'
      })

      chartData.datasets.push(dataset)
      options.layout.padding.top = 30

      return chartData
    },

    getPieDataset (dados, backgroundColor, borderColor) {
      let chartData = { labels: [], datasets: [] }
      let dataset = {
        backgroundColor: [],
        borderColor: this.$store.getters.palette.transparent,
        data: [],

      }
      let i = 0
      for (let e in dados) {
        if (!isNaN(dados[e]['total_pessoas']) && Number(dados[e]['total_pessoas']) > 0) {
          dataset.data.push(Number(dados[e]['total_pessoas']))
          dataset.backgroundColor.push(backgroundColor[i++])
          chartData.labels.push(dados[e]['faixa_etaria'])
        }
      }

      dataset.borderColor = borderColor

      chartData.datasets.push(dataset)

      return chartData
    },

    populateEscolaridade (dados, backgroundColor, borderColor) {
      let chartData = { labels: [], datasets: [] }

      let cor = CorUtils.getVetorCoresPorTom('medio')[5]
      let dataset = {
        data: [],
        backgroundColor: cor || backgroundColor,
        borderColor: cor || borderColor,
        fill: false,
      }
      for (let e in dados) {
        if (!isNaN(dados[e]['total_pessoas']) && Number(dados[e]['total_pessoas']) > 0) {
          dataset.data.push(Number(dados[e]['total_pessoas']))
          chartData.labels.push(dados[e]['grau_instrucao'])
        }
      }

      dataset.label = 'Número de Ocupantes'
      chartData.datasets.push(dataset)

      return chartData
    },

    populateRacaSexo (dados) {
      dados = _.orderBy(dados, 'total_pessoas', 'desc')
      dados = _.groupBy(dados, 'sexo')

      let backgroundColor = CorUtils.getVetorCoresPorTom('claro').slice(6)
      let chartData = { labels: [], datasets: [] }

      let totalNaoInformadoF = 0
      let totalNaoInformadoM = 0
      let totalNaoInformadoI = 0

      for (let d in dados) {
        let cor = backgroundColor.shift()
        let dataset = {
          data: [],
          backgroundColor: cor,
          borderColor: cor,
          fill: false,
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value.toLocaleString('pt-BR'),
            anchor: 'start',
            rotation: -90,
            align: 'end',
            font: {
              weight: 'bold',
            },
          },
        }

        dados[d].forEach(element => {
          if (element['raca'].includes('Não')) {
            if (element['sexo'] == 'Feminino') totalNaoInformadoF += Number(element['total_pessoas'])
            else if (element['sexo'] == 'Masculino') totalNaoInformadoM += Number(element['total_pessoas'])
            else totalNaoInformadoI += Number(element['total_pessoas'])
          } else {
            dataset.data.push(Number(element['total_pessoas']))
            if (chartData.labels.indexOf(element['raca']) == -1) chartData.labels.push(element['raca'])
            dataset.label = element['sexo']
          }
        })
        chartData.datasets.push(dataset)
      }

      chartData.datasets[0].data.push(totalNaoInformadoF)
      chartData.datasets[1].data.push(totalNaoInformadoM)
      if (totalNaoInformadoI > 0) { chartData.datasets[2].data.push(totalNaoInformadoI) }
      chartData.labels.push('Não Informado')

      return chartData
    },

    getTotal (dados) {
      let soma = 0
      dados.forEach(element => {
        soma += element['total_pessoas']
      })
      return MethGlob.formatarGrandesNumeros(soma)
    },

    populateFaixaEtaria (dados) {
      let palette = this.$store.getters.palette
      this.faixaEtaria.data = this.getPieDataset(dados, this.cores, palette.transparent)
      this.faixaEtaria.options = this.getOptionPieChart()
    },
  },
}
</script>

<style lang='scss'>

#totalPorSub, #faixaEtaria{
  height: 40rem;
}

</style>
